import { render, staticRenderFns } from "./ItemPlan.vue?vue&type=template&id=079a2447&scoped=true"
import script from "./ItemPlan.vue?vue&type=script&lang=js"
export * from "./ItemPlan.vue?vue&type=script&lang=js"
import style0 from "./ItemPlan.vue?vue&type=style&index=0&id=079a2447&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079a2447",
  null
  
)

export default component.exports